module.exports = __webpack_public_path__ + "img/pluto18.a2e4b904.jpg";